import { CalculateFinalValueForDeviation } from "./calculationForGrossAdjustedValueForDeviation";
import { calculateBCSOShares } from "./calculateBCSOShares";

export const getScheduleCFinalObligation = (WorkSheetData: any) => {
  const preexistingValue1 = WorkSheetData.pre_existing_child_support?.reduce((acc: number, item: any) => {
    return acc + Number(item.preexisting_child_support_paid_monthly1);
  }, 0) || 0;

  const preexistingValue2 = WorkSheetData.pre_existing_child_support?.reduce((acc: number, item: any) => {
    return acc + Number(item.preexisting_child_support_paid_monthly2);
  }, 0) || 0;

  const ChildValues = WorkSheetData?.proposed_adjustment_for_qualified_child
    ? WorkSheetData.proposed_adjustment_for_qualified_child.reduce(
        (acc: { parent1: number; parent2: number }, item: { adjustment_requested_by: string }) => {
          if (item.adjustment_requested_by === WorkSheetData.parent_name_1) {
            acc.parent1 = (acc.parent1 || 0) + 1;
          }
          if (item.adjustment_requested_by === WorkSheetData.parent_name_2) {
            acc.parent2 = (acc.parent2 || 0) + 1;
          }
          return acc;
        },
        { parent1: 0, parent2: 0 }
      )
    : { parent1: 0, parent2: 0 };

  const AdjustedIncome1 = CalculateFinalValueForDeviation(
    Number(WorkSheetData?.total_gross_income1),
    Number(WorkSheetData?.monthly_self_employment_income1),
    Number(preexistingValue1),
    ChildValues.parent1,
    WorkSheetData.created_at
  );

  const AdjustedIncome2 = CalculateFinalValueForDeviation(
    Number(WorkSheetData?.total_gross_income2),
    Number(WorkSheetData?.monthly_self_employment_income2),
    Number(preexistingValue2),
    ChildValues.parent2,
    WorkSheetData.created_at
  );

  const ChildCountNo = WorkSheetData?.add_child_to_worksheet?.filter(
    (child: any) => child.child_status === "included"
  ).length || 0;

  const custodialAdjustedIncome = WorkSheetData.non_custodial_parent === WorkSheetData.parent_name_1 
    ? AdjustedIncome2 : AdjustedIncome1;
  const nonCustodialAdjustedIncome = WorkSheetData.non_custodial_parent === WorkSheetData.parent_name_1 
    ? AdjustedIncome1 : AdjustedIncome2;
  
  const bcsoShares = calculateBCSOShares(
    custodialAdjustedIncome,
    nonCustodialAdjustedIncome,
    ChildCountNo,
    WorkSheetData.created_at
  );

  const A = Number(WorkSheetData.schedule_c_non_custodial_parenting_days) || 0;
  const B = Number(WorkSheetData.schedule_c_custodial_parenting_days) || 0;
  
  if (A > 0 && B > 0 && A + B === 365) {
    const numerator = Math.pow(A, 2.5) * bcsoShares.custodialShare - Math.pow(B, 2.5) * bcsoShares.nonCustodialShare;
    const denominator = Math.pow(A, 2.5) + Math.pow(B, 2.5);
    
    if (denominator !== 0) {
      const adjustment = numerator / denominator;
      return bcsoShares.nonCustodialShare + adjustment;
    }
  }
  
  return 0;
};